import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postColor } from '../Api'

export default generateApiAction({
  baseType: Types.COLORS.POST,
  api: postColor,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/colors/PostAction.js